import { ChatItemProps, ChatMessage } from '@ant-design/pro-chat';
import classNames from 'classnames';
import { ReactNode } from 'react';

interface ChatTitleProps {
  props: ChatItemProps;
  defaultDom: ReactNode;
}

const ChatTitle: React.FC<ChatTitleProps> = ({ props, defaultDom }) => {
  const chatMsg = props.originData as ChatMessage;
  const isLoadingMsg = chatMsg?.content === '...';
  const noTitle = isLoadingMsg || chatMsg?.extra?.isFollowUp;
  return (
    <div
      className={classNames(
        'chat-item-title',
        noTitle ? 'invisible' : 'visible'
      )}
    >
      {defaultDom}
    </div>
  );
};

export default ChatTitle;
